import { Component, ElementRef,  OnDestroy,  OnInit,  ViewChild } from '@angular/core';
import { Country,
  LegalForm,
  Civility,
  Supplier,
  Contact,
  Agency,
  Address,
  ExtUser,
  SimpleReponseResult,
  SupplierContact,
  SupplierAgency,
  SupplierStatut,
  InseeEtablissement,
  VW_Suppliers_Contact_Agency} from 'ngx-paf-common';
import { 
  SuppliersService,
  ExtUsersService ,
  InputCheckersService,
  SharedDataService,
   } from 'ngx-paf-common';
import { Observable, Subject, Subscription } from 'rxjs';
import {  Router } from '@angular/router';
import { AbstractControl,  FormGroup, NgForm, ValidationErrors } from '@angular/forms';

  import { filter, take } from 'rxjs/operators';

@Component({
  selector: 'app-new-supplier',
  templateUrl: './new-supplier.component.html',
  styleUrls: ['./new-supplier.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewSupplierComponent implements OnInit, OnDestroy {
  submitted = false;

  @ViewChild('frmNewSupplier') public frmNewSupplier: FormGroup;
  @ViewChild('aForm') aForm: ElementRef;

  frBtnImagePath: string=  './assets/images/FRBtn.png';
  enBtnImagePath: string=  './assets/images/ENBtn.png';
  public supplier: Supplier = new Supplier();
  public supplierContact: SupplierContact = new SupplierContact();
  public extUser: ExtUser = new ExtUser();
  public legalform?: LegalForm = null;
  public legalforms:LegalForm[]=[];
  public civility: Civility = new Civility();
  private  _country?: Country = new Country();
  public get country():Country{
    return this._country;
  }
  public set country(value:Country){
    if (value?.Id!=this._country?.Id){
      this._country = value;
      this.legalform=null;
    }
  }
  
  get lstSuppliersStatuts(): SupplierStatut[]{
    return this.sharedDatasSvc.supplierStatuts;
  }
  public useExistingContact: boolean = false;

  public siretMask: any = [/([0-9]{3}\s){3}[0-9]{5}/];

  constructor(
    private suppliersSvc: SuppliersService,
    private extUsersSvc: ExtUsersService,
    private inputCheckersSvc: InputCheckersService,
    private router: Router,
    public sharedDatasSvc: SharedDataService) {
  }



  private supplierAgency: SupplierAgency = new SupplierAgency();

  public get contact(): Contact { return this.supplierContact.Contact || new Contact(); }
  public set contact(value: Contact) { this.supplierContact.Contact = value; }

  public get agency(): Agency { return this.supplierAgency.Agency || new Agency() };
  public set agency(value: Agency) { this.supplierAgency.Agency = value };

  public get address(): Address { return this.agency.Address || new Address };
  public set address(value: Address) { this.agency.Address = value; }

  private _subscriptions: Subscription[]=[];
  ngOnInit(): void {
     if (!this.sharedDatasSvc.allListsLoaded){
      this._subscriptions.push(this.sharedDatasSvc.allListsLoadedChange.subscribe(()=>this.checkProfil()));
     } else {
      this.checkProfil();
     }
  }

  checkProfil():void {
    if (!this.sharedDatasSvc.profilLoaded){
      let sub =this.sharedDatasSvc.loggedProfilChange.subscribe(res=>{
        sub.unsubscribe();
        this.checkProfil();
      });
      return;
    }
    if (!this.sharedDatasSvc.checkProfilAccessPafSettings('NEW_SUPPLIER')){
      this.sharedDatasSvc.pafAlert('MSG_PROFIL_NON_AUTORISE_POUR_CET_ECRAN',():void=>{
          this.router.navigate(['suppliers']);
      });
    } else {
      this._initScreen();
    }
  }
  
  ngOnDestroy(): void {
     this._subscriptions.forEach(sub=>sub.unsubscribe());
  }

  private _initScreen():void{
        this.supplier.SupplierAgencies = [];
        this.supplierAgency = new SupplierAgency();
        this.supplierAgency.Agency = new Agency();
        this.supplierAgency.Agency.Address = new Address();
        this.supplierAgency.IsSupplierAgency = 1;
        this.supplier.SupplierAgencies.push(this.supplierAgency);
        this.supplierContact.Contact = new Contact();
        this.supplierContact.IsReferent = 1;
        this.supplier.LngCod = this.sharedDatasSvc.lngCod;
        this.supplier.SupplierContacts = [this.supplierContact];
        this.extUser.Contact = this.supplierContact.Contact;
        this.civility=this.sharedDatasSvc.civilities.find(c=>c.Cod=='M');
        this.country = this.sharedDatasSvc.countries.find(c=>c.CountryCod2=='FR');
  }


  public Label(lblCod:string):Observable<string>{
    return this.sharedDatasSvc.getLabel(lblCod);
}


  onCountriesLoaded(countries: Country[]): void {
    this.country = countries.find(c => c.CountryCod2 == 'FR');
  }

  onCivilitiesLoaded(civilities: Civility[]): void {
    this.civility = civilities.find(c => c.Cod == 'M');
  }
  onLegalFormsLoaded(lst: LegalForm[]): void {
    this.legalforms = lst;
    this.legalform = null;
  }


  postalCodRequired(): boolean {
    if (!this.legalform) return true;
    return (this.legalform.Ape != 2
      && this.legalform.Duns != 2
      && this.legalform.Siret != 2
      && this.legalform.Rsa != 2)
  }

  get uniqueIdToShow(): string {
    if (!this.legalform || this.legalform.Id == 0) {
      return 'postalcod';
    } else {
      if (this.legalform.Siret == 2) {
        return 'siret';
      } else if (this.legalform.Rsa == 2) {
        return 'rsa';
      } else if (this.legalform.TvaIntra == 2) {
        return 'tvaintra';
      } else if (this.legalform.Duns == 2) {
        return 'duns';
      } else {
        return 'postalcod';
      }
    }
  }

  findSiret():void{
    this.suppliersSvc.GetSupplierInseeEtablissement(this.supplier,true)
    .subscribe((etablissement:InseeEtablissement)=>{
      if (!etablissement){
        this.clearInfosSiret();
      }
    });
  }
  
  private clearInfosSiret(){
    this.supplier.SupplierName = '';
    this.address.AddrNum = '';
    this.address.Addr1 = '';
    this.address.Addr2 = '';
    this.address.PostalCod = '';
    this.address.City = '';    
  }

  supplierDetailLink(supplierId: number) : string {
   return supplierId ? `/supplier-details/${supplierId}` : '';
  }


  get IntraTvaErrorSupplierDetailLink() : string {
    let supplier : Supplier = <Supplier>this.frmNewSupplier?.controls['tvaIntra'].errors?.intraTvaUnique;
    return this.supplierDetailLink(supplier?.Id);
  }

  findIntraTva(): void {
    this.inputCheckersSvc.findIntraTva(this.supplier,this.address);    
  }



  get UniciteIntraTvaActive():boolean{
    if (!this.address) return false;
    return this.inputCheckersSvc.UniciteIntraTvaActive(this.address);
  }

  submitSupplier(): void {
    this.useExistingContact = false;
    this.createSupplier(true);
  }

  private getFormValidationErrors(f: FormGroup): any[] {
    let ret: any = [];

    Object.keys(f.controls).forEach(key => {
      const controlErrors: ValidationErrors = f.controls[key].errors;
      if (controlErrors != null) {
        f.controls[key].markAsTouched();
        Object.keys(controlErrors).forEach(keyError => {
          if (keyError != 'emailUnique') {
            ret.push({
              'Key': key,
              'KeyError': keyError,
              'Value': controlErrors[keyError]
            });
          }
        });
      }
    });
    return ret;
  }

  private setObjectsIds(): void {
    this.supplier.LegalFormId = (this.legalform?.Id||0);
    this.supplier.SupplierContacts[0].Contact.CivId = this.civility.Id;
    // this.supplier.ApeCod = null;
    // this.supplier.ApeId = null;
    this.agency.Address.CountryId = this.country.Id;
    this.agency.Address.Country = null;
    this.supplier.InternalContactEmail = this.sharedDatasSvc.loggedId;
    this.supplier.InternalContactFirstname = this.sharedDatasSvc.loggedFirstName.toUpperCase();
    this.supplier.InternalContactLastname = this.sharedDatasSvc.loggedLastName.toUpperCase();
  }

  private useExistingExtUser : boolean=false;

  public createSupplier(aCompleterParFournisseur: boolean): void {
    this.sharedDatasSvc.formRevealErrors(this.frmNewSupplier);
    let frmErrors: any = this.getFormValidationErrors(this.frmNewSupplier).filter(err=>['siretSiegeWarning'].indexOf(err.KeyError)<0);
    if (frmErrors.length > 0) {
      this.sharedDatasSvc.pafAlert('Champs_en_erreur',():void=>this.setFocus(frmErrors[0].key));
      return;
    }
    this.refreshEmailValidity(()=>this.createSupplierIfEmailOk(aCompleterParFournisseur));
  }

  private createSupplierIfEmailOk(aCompleterParFournisseur: boolean): void {
    
    this.submitted = true;
    //if (this.getFormValidationErrors(this.frmNewSupplier).length==0) {
      this.setObjectsIds();
      if (aCompleterParFournisseur) {
        //Demande de référencement envoyée
        this.supplier.StatutId = this.lstSuppliersStatuts.find(s => s.Cod == '100')?.Id;
      } else {
        //En cours de creation ENDEL
        this.supplier.StatutId = this.lstSuppliersStatuts.find(s => s.Cod == '010')?.Id;
      }
      this.supplier.FunctionalId=this.uniqueIdToShow;
      if (this.uniqueIdToShow=='siret'){
        this.supplier.TvaIntra='';
        this.supplier.Duns='';
        this.supplier.Rsa='';
      } else if  (this.uniqueIdToShow=='tvaintra'){
        this.supplier.Siret='';
        this.supplier.Duns='';
        this.supplier.Rsa='';
      } else if  (this.uniqueIdToShow=='rsa'){
        this.supplier.Siret='';
        this.supplier.Duns='';
        this.supplier.TvaIntra='';
      } else if  (this.uniqueIdToShow=='duns'){
        this.supplier.Siret='';
        this.supplier.Rsa='';
        this.supplier.TvaIntra='';
      }
      this.supplier.TopFacDemat = 1;
      this.sharedDatasSvc.WindowLock();
      this.suppliersSvc.postSupplier(this.supplier)
        .subscribe((ret: Supplier) => {
          if (ret) {
            this.supplier = ret;
            if (!this.useExistingExtUser) {
              this.getOrCreateExtUser(ret).subscribe(
                extuser=>{
                  this.extUser = extuser;
                  this.endCreateAction(aCompleterParFournisseur);
                });
            } else {
              this.suppliersSvc.getExtUser(ret.Id)
              .subscribe((result:ExtUser)=>{
                this.extUser = result;
                this.endCreateAction(aCompleterParFournisseur);                         
              });                  
            }
          } else {
            this.sharedDatasSvc.WindowUnlock();
          }
        },
        (error:any)=>{
          this.sharedDatasSvc.alert(error.error || error);
        });
    //}
  }

  endCreateAction(aCompleterParFournisseur:boolean):void{
    if (!aCompleterParFournisseur){
      this.sharedDatasSvc.WindowUnlock();
      this.router.navigate([`supplier-details/${this.supplier.Id}`]);
    } else {
      if (this.extUser.ExtUserStatut.Cod=='InitCpt'){
        this.extUsersSvc.initPassword(this.supplier)
        .subscribe(extUser2=>{
          this.informeEmailEnvoye(); 
        });
      } else {
        this.extUsersSvc.mailNotifyNewSupplier(this.extUser.Id,this.supplier.Id)
          .subscribe(resultSendMail=>{
            if (!resultSendMail.Ok){
              this.sharedDatasSvc.WindowUnlock();
              this.sharedDatasSvc.informe(resultSendMail.Message);
            } else {
              this.informeEmailEnvoye();            
            }
        }); 
      } 
    }
  }

  informeEmailEnvoye():void{
    this.sharedDatasSvc.getLabel('Le_mail_a_bien_ete_envoye').subscribe((msg:string)=>{
      msg = msg.replace('{0}',this.extUser.Email);
        this.sharedDatasSvc.informe(msg,():void=>{
          this.router.navigate([`suppliers`]);
        });
    });
  }

  private getOrCreateExtUser(ret: Supplier):Observable<ExtUser> {
    let contact = ret.SupplierContacts.find((sc:SupplierContact)=>sc.IsReferent==1)?.Contact;
    return this.createExtUser(contact);    
  }

  private createExtUser(supplierContact: Contact): Observable<ExtUser> {
      this.extUser.Contact = supplierContact;
      this.extUser.Email = supplierContact.Email;
      this.extUser.IntUserIdCreate = this.sharedDatasSvc.loggedId;
      return this.extUsersSvc.postExtUser(this.extUser);
  }


  setFocus(name: string) {
    const ele = this.aForm.nativeElement[name];
    if (ele) {
      ele.focus();
    }
  }
  continuerSaisie(): void {
    if (!this.CanSave(this.frmNewSupplier)) return;
    this.useExistingContact = false;
    this.createSupplier(false);
  }

  public showErrors: Subject<boolean> = new Subject();
  public submitShowError():void{
    this.showErrors.next(true);
  }
  public CanSave(f: FormGroup): boolean {
    this.submitShowError();// Affiche les erreurs des directives supp-contact-row
    let avecError: boolean = this.getFormValidationErrors(this.frmNewSupplier).length>0;
    if (avecError) { 
      this.sharedDatasSvc.pafAlert('Champs_en_erreur');
      return false;
    }  
    return true; 
  } 

  public get addrDisabled():boolean{
    return (this.legalform?.Id||0)==0;
  }

  getShowBtnSupplierId(frmNewSupplier:NgForm):number | undefined {
    if  (frmNewSupplier.controls['siret'] && frmNewSupplier.controls['siret'].errors) {
      if (frmNewSupplier.controls['siret'].errors.siretUnique) {
        return frmNewSupplier.controls['siret'].errors.siretUnique.Id;
      }
      if (frmNewSupplier.controls['siret'].errors.siretSiegeWarning ) {
        if (<SimpleReponseResult>(frmNewSupplier.controls['siret'].errors.siretSiegeWarning).ExtendDatas ) {
          let supplier : VW_Suppliers_Contact_Agency | undefined = <VW_Suppliers_Contact_Agency>((<SimpleReponseResult>frmNewSupplier.controls['siret'].errors.siretSiegeWarning).ExtendDatas);
          return supplier?.Id;
        }
      }
      if (frmNewSupplier.controls['siret'].errors.siretSiegeError ) {
        if (<SimpleReponseResult>(frmNewSupplier.controls['siret'].errors.siretSiegeError).ExtendDatas ) {
          let supplier : VW_Suppliers_Contact_Agency | undefined = <VW_Suppliers_Contact_Agency>((<SimpleReponseResult>frmNewSupplier.controls['siret'].errors.siretSiegeError).ExtendDatas);
          return supplier?.Id;
        }
      }
    } 
    return undefined;
  }
  countryLegalforms:LegalForm[]=[];
  onCountryChange(country:Country):void {
    this.countryLegalforms = this.sharedDatasSvc.legalForms.filter(lf=>lf.CountryId==country?.Id);
  }

refreshEmailValidity(fnContactOk:()=>any):void {
  const emailCtrl = this.frmNewSupplier.controls['email'];
  let sub = emailCtrl?.statusChanges
  .pipe(
    filter(status => status !== 'PENDING'),
    take(1) // une seule fois
  )
  .subscribe(() => {
    sub.unsubscribe();
    this.handleEmailValidationResult(emailCtrl,fnContactOk);
  });  
  emailCtrl.updateValueAndValidity();
}

handleEmailValidationResult(control: AbstractControl | null, fnContactOk:()=>any) {
  if (!control) return;
  const emailError = control.errors?.['emailUnique'];
  if (emailError) {
    const contactExistant = emailError.contact; 
    let msg = this.sharedDatasSvc.getLoadedLabel('Email_existant_confirmation');
    this.sharedDatasSvc.confirm(msg.replace('&1', contactExistant.Email), () => {
      this.contact.Id = contactExistant.Id;
      this.supplierContact.ContactId = contactExistant.Id;
      let param: ExtUser = new ExtUser();
      param.ContactId=contactExistant.Id;
      this.extUsersSvc.search(param)
      .subscribe((xusers:ExtUser[])=>{
        if (xusers && xusers.length>0){
          this.extUser = xusers[0];
          this.useExistingExtUser = true;
        } else {
          this.extUser = new ExtUser();
          this.extUser.ContactId = contactExistant.Id;
          this.extUser.Email = contactExistant.Email;
          this.useExistingExtUser = false;
        }
        control.setErrors(null); 
        fnContactOk(); 
      });
    },null);
  } else {
    fnContactOk();
  }
}




}
